module.exports = __webpack_public_path__ + "fonts/Gotham-Book.954cbd87.otf";